module.exports = __webpack_public_path__ + "media/1x1/sg-9eb47fe7.svg";